import { ThemeProvider, Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch-dom";
import { Outlet, useLocation } from "react-router-dom";

import { useCheckMaintenanceBannerQuery } from "api/app/app.api";
import LoadingSpinner from "components/UI/LoadingSpinner/LoadingSpinner";
import { useAuth } from "hooks/useAuth";
import defaultNiapTheme from "theme";

import AppLogout from "./components/AppLogout";
import DailyDeployBanner from "./components/DailyDeployBanner";
import DevBanner from "./components/DevBanner";
import Footer from "./components/Footer/Footer.screen";
import NavigationBar from "./components/NavigationBar/NavigationBar";
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";

const searchClient = algoliasearch(
  import.meta.env.VITE_ALGOLIA_APP_ID,
  import.meta.env.VITE_ALGOLIA_SEARCH_KEY,
);

const BANNER_HEIGHT = 56;

function App() {
  const { oldAuthToken } = useAuth();

  const location = useLocation();
  const onLoginScreen = location.pathname.includes("login");
  const { data: bannerEnabled = false } = useCheckMaintenanceBannerQuery();
  const shouldShowBanner = bannerEnabled && !onLoginScreen;
  const isDev = Boolean(
    import.meta.env?.VITE_REACT_ENDPOINT === "https://dev.niap-ccevs.org/",
  );

  return (
    <div className={oldAuthToken ? "border border-5 border-danger" : ""}>
      <InstantSearch searchClient={searchClient} indexName="test_HBD">
        <ThemeProvider theme={defaultNiapTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <LoadingSpinner />
            <Box sx={{ mt: `${isDev ? BANNER_HEIGHT : 0}px` }}>
              <AppLogout>
                {shouldShowBanner && <DailyDeployBanner />}
                {isDev && <DevBanner bannerHeight={BANNER_HEIGHT} />}

                <ScrollToTop />

                <div className="header">
                  <NavigationBar />
                </div>

                <Outlet />

                <Footer />
              </AppLogout>
            </Box>
          </LocalizationProvider>
        </ThemeProvider>
      </InstantSearch>
    </div>
  );
}

export default App;
